import { Link } from 'react-router-dom'
import { BACKEND_URL } from '../../util'
import { cornerClass } from '../ImageCorners/ImageCorners'
import type { CornerStyle } from '../ImageCorners/ImageCorners'
import styles from './GridGallery.module.css'

type GridGalleryItem = {
  caption: string
  description: string
  imageId: string
  link: string
  cornerStyle?: CornerStyle
}

type GridGalleryProps = {
  items: GridGalleryItem[]
  elementsPerRow?: number
}

function GridGalleryItem({ item }: { item: GridGalleryItem }) {
  return (
    <Link
      to={item.link}
      className={`${styles.item} ${cornerClass(item.cornerStyle, { tile: true, clip: true })}`}
    >
      <div className={styles.imageContainer}>
        <img className={styles.image} src={`${BACKEND_URL}file/${item.imageId}`} alt={item.caption} />
        <div className={styles.gradient}></div>
        <div className={styles.overlay}></div>
        <div className={styles.textContainer}>
          <div className={styles.caption}>{item.caption}</div>
          <div className={styles.description}>{item.description}</div>
        </div>
      </div>
    </Link>
  )
}

function GridGallery({ items, elementsPerRow = 3 }: GridGalleryProps) {
  return (
    <div className={styles.container}>
      <div
        className={styles.grid}
        style={{ ['--columns' as any]: elementsPerRow }}
      >
        {items.map((item, index) => (
          <GridGalleryItem key={`${item.imageId}-${index}`} item={item} />
        ))}
      </div>
    </div>
  )
}

export { GridGallery }
export type { GridGalleryItem } 